export const PRIVACY_POLICY = '//forms.vis-its.com/ic/privacy_policy';
export const COMPANY = '//visits.world';
export const DTT_LP = '//design-thinking-test.com';
export const DTT_LOGIN = '//design-thinking-test.com/login';
